<xm-radio xmRadioControl class="tier" [name]="unlimitedTierPlan.radioOption.groupName"
    [value]="unlimitedTierPlan.radioOption.value" [option]="unlimitedTierPlan.radioOption"
    (onSelect)="tierSelect($event)">
    <div class="wrapper">
        <div class="left-section">
            <span class="tier-name">{{ unlimitedTierPlan.name }}</span>
            <p *ngIf="!showInUseBadge" class="tier-name">{{ priceSymbol }}${{ tierPrice }}/{{ unlimitedTierPlan.priceUnit }}</p>
            <div *ngIf="showInUseBadge" class="badge" role="status" [attr.aria-label]="unlimitedTierPlan.name + ' is ' + inUse">
                <xm-media-image [imageOptions]="inUseIcon" class="badge-icon" center="auto" size="auto">
                </xm-media-image>
                <span class="badge-text">{{ inUse }}</span>
            </div>

            <div *ngIf="showScheduledBadge" class="badge" role="status" [attr.aria-label]="unlimitedTierPlan.name + ' is ' + scheduled">
                <xm-media-image [imageOptions]="scheduledIcon" class="badge-icon schedule-icon"
                    center="auto" size="auto">
                </xm-media-image>
                <span class="badge-text">{{ scheduled }}</span>
            </div>
        </div>

        <div class="vertical-divider"></div>

        <ul class="right-section">
            <li *ngFor="let detail of unlimitedTierPlan.details">{{ detail }}</li>
        </ul>
    </div>
</xm-radio>
